import {
 baseAPI,
 baseTransformResponse,
 baseTransformResponse4,
} from 'api/baseApi'
import { secondAPI } from 'api/secondApi'
import { ApiResponce, TGroupName } from 'types'
import { TSelectAllB } from 'features/leads'
import {
 TAlertControlType,
 TAlertFeedType,
 TAlertStatus,
 TGetAlertName,
 TGetAlertNameBody,
 TPutAlertType,
} from '../types'

export const alertApi = baseAPI.injectEndpoints({
 endpoints: ({ query, mutation }) => ({
  AddNewAlert: mutation<void, TPutAlertType>({
   query: (body) => ({
    url: 'user/put-alert',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse,
   invalidatesTags: ['LEAD'],
  }),
  EditNewAlert: mutation<void, TPutAlertType>({
   query: ({ id, ...body }) => ({
    url: `user/update-alert/${id}`,
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse,
   invalidatesTags: ['LEAD'],
  }),
  getAlertNames: query<TGetAlertName[], TGetAlertNameBody>({
   query: (body) => ({
    url: 'user/get-alert-name',
    method: 'post',
    body,
   }),
   transformResponse: (res: ApiResponce) => res.data,
  }),
  controlAlert: mutation<
   void,
   {
    alert_id: any
    lead_id?: any
    action: TAlertStatus
    type: TAlertControlType
    select_all?: any
    unselected?: any
   }
  >({
   query: (body) => ({
    url: 'user/control-alerts',
    method: 'post',
    body,
   }),
   invalidatesTags: ['LEAD'],
   transformResponse: baseTransformResponse,
  }),
  deleteBulkAlert: mutation<
   void,
   TSelectAllB & { id?: any[]; feed?: TAlertFeedType }
  >({
   query: (body) => ({
    url: 'user/delete-alerts',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse,
  }),
  withdrawBulkAlert: mutation<
   void,
   { type?: TGroupName; type_id?: any; alert_id?: any }
  >({
   query: (body) => ({
    url: 'user/withdraw-alert-bulk',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse,
  }),
  withdrawAlert: mutation<void, { lead_id?: any; alert_id?: any[] }>({
   query: (body) => ({
    url: 'user/withdraw-alert',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse,
  }),

  assignAlertBulk: mutation<
   void,
   { type?: TGroupName; type_id?: any[]; alert_id?: any[] }
  >({
   query: (body) => ({
    url: 'user/assign-alert-bulk',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse,
  }),
  assignToActionPlanLead: mutation<
   any,
   {
    lead_id: any[]
    actionplan_id?: any[]
    type?: 'action-plan'
   }
  >({
   query: (body) => ({
    url: 'user/assign-action-plan-lead',
    method: 'post',
    body,
   }),
   transformResponse: (res: any) => {
    baseTransformResponse4(res)
    return res
   },
  }),
  assignToLeadAlert: mutation<
   void,
   { lead_id: any[]; alert_id?: any[]; feed?: TAlertFeedType }
  >({
   query: (body) => ({
    url: 'user/assign-alert-lead',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse,
  }),
 }),
})

export const {
 useWithdrawAlertMutation,
 useAssignAlertBulkMutation,
 useAssignToLeadAlertMutation,
 useAssignToActionPlanLeadMutation,
 useAddNewAlertMutation,
 useEditNewAlertMutation,
 useGetAlertNamesQuery,
 useDeleteBulkAlertMutation,
 useWithdrawBulkAlertMutation,
 useControlAlertMutation,
} = alertApi

// export const alertApi1 = secondAPI.injectEndpoints({
//  endpoints: ({ query, mutation }) => ({
//   getAlertFilters: query<
//    {
//     building_type?: string[]
//     listing_status?: string[]
//     listing_type?: string[]
//    },
//    { val?: string }
//   >({
//    query: ({ val }) => ({
//     url: `api/get-alert-filters${val}`,
//     method: 'get',
//    }),
//    transformResponse: (res: ApiResponce) => res.data,
//   }),
//  }),
// })

// export const { useGetAlertFiltersQuery } = alertApi1
